<template>
  <div class="pt-8">
    <!-- {{ $t('errors.collegiate_not_allow_to_prescribe') }}
    <div class="actions">
      <v-btn color="primary" depressed class="white--text" @click="goToProfile">
        {{ $t('common.go_to_profile') }}
      </v-btn>
    </div> -->

    <WarningMessage>
      Estamos experimentando una incidencia en el servicio de receta electrónica que esperamos resolver a la mayor brevedad posible. Disculpe las molestias ocasionadas.
    </WarningMessage>
  </div>
</template>
<script>
import { accountNamePaths } from '@/router/routes';
import WarningMessage from '@/components/organisms/WarningMessage/WarningMessage.vue';

export default {
  components: {
    WarningMessage,
  },
  name: 'CollegiateNotAllowToPrescribeMsg',
  methods: {
    goToProfile() {
      this.$router.push({ name: accountNamePaths.profile });
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;

  :not(:last-child) {
    margin-right: 1rem;
  }
}
</style>
